#!/usr/bin/env node
import cli from "./cli/index.js";

cli();
